<div class="container-fluid">
  <form class="theme-form mega-form" [formGroup]="bonusForm">
    <div
      *ngIf="idRol !== agente"
      class="alert alert-info p-2 d-flex align-items-center mb-3"
      role="alert"
    >
      <i class="fa-solid fa-circle-info me-2"></i>
      <span>Selecciona un agente y luego el tipo de bono que deseas crear libremente.</span>
    </div>

    <div class="form-block" *ngIf="idRol !== agente">
      <div class="section-divider">
        <span class="form-block__title">Agente</span>
      </div>
      <div class="row g-3 mt-2">
        <div class="col-md-12">
          <label class="form-check-label field-label">Selecciona un agente <span class="required-mark">*</span></label>
          <ng-select
            [items]="isAgent ? allAgentsData : allPlayersData"
            bindLabel="label"
            bindValue="value"
            required
            formControlName="id_agente"
            class="mb-2"
            placeholder="Selecciona un agente"
            (scrollToEnd)="onScrollToEnd()"
            (search)="onSearch($event.term)"
            (clear)="onSearch('')"
            (open)="onSearch('')"
          ></ng-select>
          <div
            *ngIf="
              bonusForm.controls.id_agente.touched &&
              bonusForm.controls.id_agente.errors?.required
            "
            class="text-danger font-error mt-2"
          >
            Selecciona un agente!.
          </div>
        </div>
      </div>
    </div>

    <div class="form-block">
      <div class="section-divider">
        <span class="form-block__title">Configuracion del bono</span>
      </div>

      <div class="row g-3 mt-2">
        <div class="col-md-6 mb-3">
          <div class="field-header">
            <label class="form-label field-label mb-0">
              Tipo de Bono <span class="required-mark">*</span>
            </label>
          </div>
          <ng-select
            [items]="allTypeBonusData"
            bindLabel="label"
            bindValue="value"
            formControlName="tipo_bono"
            class="mb-2"
            [placeholder]="bonusForm.get('id_agente')?.value ? 'Seleccione una opción' : 'Primero selecciona un agente'"
            [clearable]="false"
            [searchable]="true"
            [loading]="isLoadingBonusTypes"
            [readonly]="!bonusForm.get('id_agente')?.value || isLoadingBonusTypes"
            (change)="onSelectChange($event)"
          ></ng-select>
          <div class="text-muted font-error mt-2" *ngIf="isLoadingBonusTypes">
            Cargando tipos de bono...
          </div>
          <div
            class="text-danger font-error mt-2"
            *ngIf="
              bonusForm.controls.tipo_bono!.touched &&
              bonusForm.controls.tipo_bono.errors?.required
            "
          >
            Selecciona un tipo de bono!.
          </div>
        </div>

        <div class="col-md-6">
          <div class="field-header">
            <label class="form-label field-label mb-0">
              Monto recarga <span class="required-mark">*</span>
            </label>
          </div>
          <div class="input-group">
            <span class="input-group-text">
              {{ id_country === 1 ? "$" : "S/." }}
            </span>
            <input
              class="form-control"
              type="text"
              placeholder="0.00"
              [attr.disabled]="!bonusForm.get('id_agente')?.value ? true : null"
              (keypress)="onKeyPressSpecial($event)"
              (input)="onRechargeAmountChange()"
              formControlName="monto_recarga"
            />
          </div>
        </div>
      </div>

      <div class="row g-3">
        <div class="col-md-6">
          <div class="field-header">
            <label class="form-label field-label mb-0">
              Cantidad de Bonos <span class="required-mark">*</span>
            </label>
          </div>
          <div class="input-group">
            <input
              class="form-control"
              type="number"
              formControlName="fracciones"
              step="1"
              [attr.disabled]="!bonusForm.get('id_agente')?.value ? true : null"
              (input)="onInputChange($event)"
            />
          </div>
        </div>

        <div class="col-md-6">
          <div class="field-header field-header--with-badge">
            <label class="form-label field-label mb-0">Monto por Bono</label>
            <span class="badge text-bg-light bonus-badge">Auto</span>
          </div>
          <div class="input-group">
            <span class="input-group-text">
              {{ id_country === 1 ? "$" : "S/." }}
            </span>
            <input
              class="form-control"
              type="text"
              placeholder="0.00"
              formControlName="monto"
              readonly
            />
          </div>
        </div>
      </div>
    </div>

    <div class="form-block">
      <div class="section-divider">
        <span class="form-block__title">Observaciones</span>
      </div>
      <div class="row g-3 mt-2">
        <div class="col-md-12 mb-3">
          <label class="form-label field-label">
            Detalle <span class="optional-text">(opcional)</span>
          </label>
          <textarea
            class="form-control"
            formControlName="comentario"
            rows="4"
            placeholder="Escribe una observación o referencia interna..."
          ></textarea>
          <div class="character-counter mt-2">
            {{ (bonusForm.get("comentario")?.value || "").length }} caracteres
          </div>
        </div>
      </div>
    </div>

    <div class="text-end">
      <button class="btn btn-cancel me-2" type="button" (click)="closeModal()">
        Cancelar
      </button>
      @if (isLoadingButton) {
        <button class="btn btn-create" type="button" disabled>
          <i class="fas fa-ticket-alt fa-spin fa-xs me-1"></i>Creando Bono
        </button>
      } @else {
        <button
          type="button"
          class="btn btn-create"
          [disabled]="!isFormValid()"
          (click)="sendFormData()"
        >
          Crear Bono Libre
        </button>
      }
    </div>
  </form>
</div>
